import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query/types/react/types';
import { LoginConfigApi, SetDefaultLocaleDto } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseSetDefaultLocale = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    SetDefaultLocaleDto>,
    'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>,
  ErrorResponse,
  SetDefaultLocaleDto>;

export const useSetDefaultLocale: UseSetDefaultLocale = (
  options,
) => {
  const loginConfigApi = new LoginConfigApi(getApiConfiguration());
  return useMutation(
    (setDefaultLocaleDto: SetDefaultLocaleDto) =>
      loginConfigApi.setDefaultLanguage(setDefaultLocaleDto),
    options,
  );
};
